import { Injectable } from "@angular/core";
import { ProductType } from "@obg/core.config";
import { CacheFactory, CacheStore, fromSecondsToMilliseconds, SchedulerService, StorageMode } from "@obg/ngx.global";
import { RouteService } from "@obg/ngx.router";

import { PreloadConfigService } from "./preload.config";

export const PRELOAD_TIMEOUT = fromSecondsToMilliseconds(3);
export const LAST_PRODUCT_KEY = "lastProduct";
const CACHE_STORE_KEY = "core.preload";

@Injectable({
	providedIn: "root",
})
export class PreloadService {
	private cache: CacheStore;

	constructor(
		private routeService: RouteService,
		private schedulerService: SchedulerService,
		private config: PreloadConfigService,
		cacheFactory: CacheFactory
	) {
		this.cache = cacheFactory.get(CACHE_STORE_KEY, {
			isLanguageSpecific: false,
			isVersionSpecific: false,
			maxAge: Number.MAX_SAFE_INTEGER,
			storageMode: StorageMode.LocalStorage,
		});
	}

	saveLastProduct(product: ProductType): Promise<ProductType> {
		return this.cache.setItem(LAST_PRODUCT_KEY, product);
	}

	preload(product: ProductType.Common | ProductType.ProviderPlugin) {
		if (product === ProductType.ProviderPlugin) {
			this.routeService.loadModule(ProductType.Casino);
			return;
		}

		this.schedulerService.requestIdle(
			() =>
				this.cache
					.getItem<ProductType>(LAST_PRODUCT_KEY)
					.then((lobby) => (lobby ? [lobby] : this.config.getDefaultProductsToPreload()))
					.then((lobbies) => {
						for (const lobby of lobbies) {
							this.routeService.loadModule(lobby);
						}
					}),
			{ timeout: PRELOAD_TIMEOUT }
		);
	}
}
